export const EmploymentTypeEN = {
  "EmploymentTypeAdd": {
    "EmploymentTypeAdd": "Add employment type ",
    "EmploymentTypeEdit": "Edit employment type",
    "EmploymentTypeDelete": "Delete employment type",
    "ListEmploymentType": "List employment type",
    "EmploymentType" : "Employment type"
  },
  "EmploymentTypeTitle": {
    "name" : "Name employment Type",
    "status" : " Status",
    "active" : "Active",
    "inactive" : "InActive"
  },
  "placeholderEmploymentType": {
    "name" : "Name employment type"
  },
  "buttonEmploymentType": {
    "buttonSubmit": "Submit",
    "buttonUpdate": "Edit",
    "buttonCancel": "Cancel"
  },
  "NotificationEmploymentType": {
    "edit": "Edit data successfully...",
    "add": "Add data successfully...",
    "delete": "Delete data successfully...",
    "question": " Do you want to delete ? ",
    "title" : "update employment type ",
    "required" : " is required!"
  }
}